/* match the legacy CarouselSwiper gutters: 16px on mobile, 64px on tablet+ */
.redesignCarousel {
  margin-left: 16px;
  margin-right: 16px;
}

@media all and (--reefer-media-tablet-min) {
  .redesignCarousel {
    margin-left: 64px;
    margin-right: 64px;
  }
}
